import React from 'react';
import Button from "./ripple/Button";

export default class Popover extends React.Component {

    renderPopover = () => {

        let link = this.props.link ? this.props.link : '';
        let ariaLabel = this.props.ariaLabel ? this.props.ariaLabel : '';
        let className = this.props.className ? this.props.className : 'popover';

        return (
            <div aria-label={ariaLabel} className={className}>
                <i className="far fa-question-circle popover__hint" aria-hidden="true"/>
                <div className='popover__message'>
                    {this.props.children}
                    {link &&
                        <Button
                            title='Read more'
                            displayType='text'
                            className='popover__message__readMore'
                            onClick={() => {window.open(link, '_blank')}}
                        />
                    }
                </div>
            </div>
        )
    };

    render() {
        return this.renderPopover();
    }

}